<template>
  <vab-icon
    icon="app-store-line"
    @click="handleClick"
  />
  <my-menu ref='myMenu' />
</template>

<script>
  import { ref, computed, getCurrentInstance } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute, useRouter } from 'vue-router'
  import MyMenu from './menu.vue'

  export default {
    name: 'VabMyMenu',
    components: { MyMenu },
    setup() {
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const { proxy } = getCurrentInstance()
      const extra = computed(() => store.getters['settings/extra'])
      const theme = computed(() => store.getters['settings/theme'])
      const visitedRoutes = computed(() => store.getters['tabs/visitedRoutes'])
      const myMenu = ref(null)

      const handleClick = () => {
        myMenu.value.showMenu()
      }

      return {
        theme,
        myMenu,
        handleClick,
      }
    },
  }
</script>
